var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-avatar-img",style:({
    width: `${_vm.size}px`,
    height: `${_vm.size}px`,
    lineHeight: `${_vm.size}px`,
    fontSize: `${Math.floor(_vm.size / 2)}px`
  })},[(_vm.$store.$storeUser.userAvatarObjectURL && _vm.isSelf)?_c('LazyImg',{staticClass:"avatar-img",attrs:{"src":_vm.$store.$storeUser.userAvatarObjectURL,"crossOrigin":_vm.crossOrigin,"noBackground":true}}):(_vm.id || _vm.def)?_c('LazyImg',{staticClass:"avatar-img",attrs:{"src":_vm.imgUrl,"crossOrigin":_vm.crossOrigin,"noBackground":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }